module.exports = __webpack_public_path__ + "9bdc847bc3ba06474a93f803b06782f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/3/Assets/img2.jpg
// module id = 1355
// module chunks = 0